export default __webpack_public_path__ + "static/lightStatic-11063d057f70a7a0a002773b5ab46f26.webp";